import { getPageType } from '~/events/utils/pageType'
import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'
import productTransformer from './transformers/product.transformer'

eventBus.$on(eventDefinitions.CART.LOADED, ({ cart }) => {
  if (!cart?.cartData?.items || !Array.isArray(cart.cartData.items)) {
    handleEmptyCartEvent(eventDefinitions)
    return
  }

  const transformedItems = cart.cartData.items
    .filter(item => item.shoppable && item.product)
    .map((item, i) =>
      productTransformer(
        item.product,
        item.amount,
        item.prices.unitWithoutTax,
        item.prices.unitWithTax,
        i,
        item.attributes?.custom?.colour ?? null,
        item.attributes?.custom?.master_item_id ?? null,
      ),
    )

  if (transformedItems.length === 0) {
    handleEmptyCartEvent(eventDefinitions)
    return
  }

  const cartTotals = calculateCartTotals(transformedItems)
  const dataLayerPayload = prepareDataLayerPayload(
    eventDefinitions,
    cart.cartData.currencyCode,
    transformedItems,
    cartTotals,
  )

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(dataLayerPayload)
})

/**
 * Calculates cart totals based on transformed items.
 */
const calculateCartTotals = items => ({
  totalValue: items.reduce((sum, item) => sum + item.price * item.quantity, 0),
  totalValueVat: items.reduce((sum, item) => sum + item.price_vat * item.quantity, 0),
  mktValAll: items.reduce((sum, item) => sum + item.price * item.quantity, 0),
  productsCntTotal: items.reduce((sum, item) => sum + item.quantity, 0),
  productsCntUnique: items.length,
})

/**
 * Prepares the data layer payload for Google Tag Manager.
 */
const prepareDataLayerPayload = (eventDefinitions, currency, items, totals) => ({
  event: 'cart',
  cart_detail: {
    cart_empty: false,
    products_cnt_total: totals.productsCntTotal,
    products_cnt_unique: totals.productsCntUnique,
    products_price: totals.totalValue,
    products_price_vat: totals.totalValueVat,
    currency,
    mkt_val_all: totals.mktValAll,
    page_type: getPageType(),
    items,
    google_tag_params: {
      ecomm_pagetype: getPageType(),
      ecomm_prodid: items.map(item => String(item.item_id)),
      ecomm_totalvalue: totals.totalValue,
      ecomm_totalvalue_all: items.map(item => item.price * item.quantity),
    },
  },
})

/**
 * Handles the scenario where the cart is empty.
 */
const handleEmptyCartEvent = eventDefinitions => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'cart',
    cart_detail: {
      cart_empty: true,
      products_cnt_total: 0,
      products_cnt_unique: 0,
      products_price: 0,
      products_price_vat: 0,
      currency: 'CZK',
      mkt_val_all: 0,
      page_type: getPageType(),
      items: [],
      google_tag_params: {
        ecomm_pagetype: getPageType(),
        ecomm_prodid: [],
        ecomm_totalvalue: 0,
        ecomm_totalvalue_all: 0,
      },
    },
  })
}
